import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../infrastructure/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  return authService.isLoggedIn().pipe(
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        authService.redirectToLogin();
        return false;
      }
      return true;
    }),
  );
};
